import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LocationComponentService {
  API_SERVER: string = environment.baseApiUrl;
  reloadTable$ = new BehaviorSubject(false);

  constructor(private httpClient: HttpClient) {}

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  findAll(params?): Observable<any> {
    let Params = new HttpParams();
    if (params && Object.keys(params).length > 0) {
      params.forEach((elem) => {
        Params = Params.append(elem.key, elem.val);
      });
    }

    return this.httpClient
      .get(this.API_SERVER + 'location-components', { params: Params })
      .pipe(map(this.extractData));
  }

  findOne(id): Observable<any> {
    return this.httpClient
      .get(this.API_SERVER + `location-components/${id}`)
      .pipe(map(this.extractData));
  }

  create(data): Observable<any> {
    return this.httpClient
      .post(this.API_SERVER + 'location-components', data)
      .pipe(map(this.extractData));
  }

  update(id, data): Observable<any> {
    return this.httpClient
      .put(this.API_SERVER + `location-components/${id}`, data)
      .pipe(map(this.extractData));
  }

  remove(id): Observable<any> {
    return this.httpClient
      .delete(this.API_SERVER + `location-components/${id}`)
      .pipe(map(this.extractData));
  }

  removeWithAnnotations(id): Observable<any> {
    return this.httpClient
      .delete(this.API_SERVER + `location-components/${id}/annotation`)
      .pipe(map(this.extractData));
  }

  restoreWithAnnotations(id): Observable<any> {
    return this.httpClient
      .delete(this.API_SERVER + `location-components/restore/${id}/annotation`)
      .pipe(map(this.extractData));
  }
}
